module.exports = __webpack_public_path__ + "static/type-brigade-50-CommercialClassics28-3f8322db12fe0c782290baea76839952.jpg";